import { useState, useEffect, useCallback } from 'react';

interface TenantValidationResult {
  isValid: boolean;
  isLoading: boolean;
  error: string | null;
  tenantSlug: string | null;
}

export function useTenantValidation(): TenantValidationResult {
  const [result, setResult] = useState<TenantValidationResult>({
    isValid: false,
    isLoading: true,
    error: null,
    tenantSlug: null,
  });

  const validateTenant = useCallback(async () => {
    const host = window.location.host;
    const match = host.match(/^(?<tenant>[a-zA-Z0-9-]+)\.lyrax\.cl$/);

    if (!match?.groups?.tenant) {
      setResult({
        isValid: true,
        isLoading: false,
        error: null,
        tenantSlug: null,
      });
      return;
    }

    const tenantSlug = match.groups.tenant;

    if (['www', 'app', 'api', 'admin'].includes(tenantSlug)) {
      setResult({
        isValid: true,
        isLoading: false,
        error: null,
        tenantSlug: null,
      });
      return;
    }

    setResult(prev => ({
      ...prev,
      tenantSlug,
      isLoading: true,
    }));

    try {
      console.log('[useTenantValidation] Validating tenant:', tenantSlug);
      console.log('[useTenantValidation] Request URL:', `/api/tenants/validate/${tenantSlug}`);

      const response = await fetch(`/api/tenants/validate/${tenantSlug}`);
      const data = await response.json();

      console.log('[useTenantValidation] Response status:', response.status);
      console.log('[useTenantValidation] Response OK:', response.ok);
      console.log('[useTenantValidation] Response data:', JSON.stringify(data, null, 2));
      console.log('[useTenantValidation] data.data?.exists:', data.data?.exists);

      if (!response.ok || !data.data?.exists) {
        console.error('[useTenantValidation] Validation FAILED');
        console.error('[useTenantValidation] Reason:', !response.ok ? 'Response not OK' : 'Tenant does not exist');
        setResult({
          isValid: false,
          isLoading: false,
          error: 'Tenant not found',
          tenantSlug,
        });
        return;
      }

      console.log('[useTenantValidation] Validation SUCCESS');

      setResult({
        isValid: true,
        isLoading: false,
        error: null,
        tenantSlug,
      });
    } catch (error) {
      setResult({
        isValid: false,
        isLoading: false,
        error: 'Validation failed',
        tenantSlug,
      });
    }
  }, []);

  useEffect(() => {
    validateTenant();
  }, [validateTenant]);

  return result;
}
